import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import ActivePage from "../../../partials/active-page";
import NewDesignationForm from "./NewDesignation.jsx";
import {
	GET_DESIGNATION,
	NEW_DESIGNATION,
	UPDATE_DESIGNATION
} from "../../../queries/designation.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import AlertMessage from "../../../partials/alertMessage";
import LoadingSpinner from "../../../partials/loading";
import DesignationList from "./DesignationList";
import auth from "../../../providers/Auth.Provider";
import UpdateDesignation from "./UpdateDesignation.jsx";

const Designation = ({ match }) => {
	// local state
	const [newDesignation, setNewDesignation] = useState(false);
	const [designation, setDesignation] = useState(null);
	// site
	const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
	const { site } = GetToken() && GetAuthenticatedStaff();

	// prepare query
	const { loading: gLoading, data: gData, error: gError } = useQuery(
		GET_DESIGNATION,
		{ variables: { site: site && site.id } }
	);

	// prepare mutation
	const [
		CreateDesignation,
		{ loading: nLoading, data: nData, error: nError }
	] = useMutation(NEW_DESIGNATION, {
		update(
			caches,
			{
				data: { CreateDesignation }
			}
		) {
			const { GetAllDesignation } = caches.readQuery({
				query: GET_DESIGNATION,
				variables: { site: site && site.id }
			});
			// update
			GetAllDesignation.docs.unshift(CreateDesignation.doc);
			// write back
			caches.writeQuery({
				data: { GetAllDesignation },
				variables: { site: site && site.id },
				query: GET_DESIGNATION
			});
		}
	});

	// prepare Update mutation
	const [
		UpdateDesignationFunc,
		{ loading: uLoading, data: uData, error: uError }
	] = useMutation(UPDATE_DESIGNATION);
	// props
	const title = "Staff Designation";
	const pages = [
		{
			title: "Application Management",
			path: "/home/app-management"
		},
		{ title, path: match.path }
	];

	return (
		<>
			<Helmet>
				<title>
					{title} | {appName}
				</title>
			</Helmet>
			<ActivePage pages={pages} title={title} />

			<div className="row justify-content-center">
				{newDesignation && (
					<div className="col-md-8 col-sm-12 fade-in">
						<div className="card">
							<div className="card-head">
								<header>New Designation</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={nLoading} />
								<AlertMessage
									message={nError && nError.message}
									failed={true}
								/>
								<AlertMessage
									message={nData && nData.CreateDesignation.message}
									failed={false}
								/>
								<NewDesignationForm
									onCancel={() => setNewDesignation(false)}
									onSubmit={async name => {
										await CreateDesignation({
											variables: { site: site && site.id, name }
										});
									}}
								/>
							</div>
						</div>
					</div>
				)}
				{designation && (
					<div className="col-md-8 col-sm-12 fade-in">
						<div className="card">
							<div className="card-head">
								<header>Update Designation</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={uLoading} />
								<AlertMessage
									message={uError && uError.message}
									failed={true}
								/>
								<AlertMessage
									message={uData && uData.UpdateDesignation.message}
									failed={false}
								/>
								<h5>{designation.name}: </h5>
								<UpdateDesignation
									onCancel={() => {
										setDesignation(null);
										setNewDesignation(false);
									}}
									onSubmit={async name => {
										await UpdateDesignationFunc({
											variables: { id: designation.id, name }
										});
									}}
									currentValue={designation.name}
								/>
							</div>
						</div>
					</div>
				)}
				<div className="col-md-8 col-sm-12">
					<div className="card">
						<div className="card-head">
							<header>Designation List</header>
							<div className="tools">
								<button
									title="Add Designation"
									onClick={() => {
										setNewDesignation(true);
										setDesignation(null);
									}}
									className="mdl-button mdl-button--icon margin-right-10 btn-success"
								>
									<i className="material-icons">add</i>
								</button>
							</div>
						</div>
						<div className="card-body">
							<LoadingSpinner loading={gLoading} />
							<AlertMessage message={gError && gError.message} failed={true} />
							{!gLoading && (
								<DesignationList
									items={gData && gData.GetAllDesignation.docs}
									onEdit={item => {
										setDesignation(item);
										setNewDesignation(false);
										document.body.scrollTop = 0;
										document.documentElement.scrollTop = 0;
									}}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Designation;
